import { IPagedParameters, IPagedResult } from "@/core/model/sys/IPagedParameters";
import BaseService from "../base/BaseService";
import IParamServices from "../IParamServices";
import { IEdoCtaReport } from "@/core/model/reports/EdoCtaReport";
import { IServiceResponse } from "@/core/model/rest/IServiceResponse";
import { IContract } from "@/core/model/sys/IContract";
import { ICustomer } from "@/core/model/sys/ICustomer";
import { IInvoicePayment, IPaymentsPeriodSummary } from "@/core/model/sys/IInvoicePayment";

export default class ReportsService extends BaseService
{
  constructor(param: IParamServices)
  {
    super(param);
  }
  public async ReportEdoCtaCustomer(customer:ICustomer,ini?:Date,fin?:Date,Contract?:IContract):Promise<IEdoCtaReport|null>
  {
    const params = {
      Id:customer.Gid,
      ContractId:Contract?Contract.Gid:null,
      Ini:ini,
      Fin:fin,
    }
    const response:IServiceResponse = await this.Post(`IndexEdoCta/ReportEdoCtaCustomer`,params ,null,null,null,true,false,null); 
    if(response && response.Response)
    {
      const edo:IEdoCtaReport = {...response.Response};      
      return edo;
    } 
    else
    return null;
  }
  public async ReportEdoCtaContract(contract:IContract,ini?:Date,fin?:Date):Promise<IEdoCtaReport|null>
  {
    const params = {
          Id:contract.Gid,
          Ini:ini,
          Fin:fin,
        }    
    const response:IServiceResponse = await this.Post(`IndexEdoCta/ReportEdoCtaContract`,params ,null,null,null,true,false,null); 
    if(response && response.Response)
    {
      const edo:IEdoCtaReport = {...response.Response};      
      return edo;
    } 
    else
      return null;
  }
  public async ReportEdoCtaExcel(filter?:string):Promise<any>
  {
    const filters = {
      Search: filter
    }  
    const response:IServiceResponse = await this.Post(`IndexEdoCta/ReportEdoCtaExcel`,filters,null,null,null,true,undefined,'arraybuffer' );
    return response;
  }
  public async ReportEdoCta(paged:IPagedParameters,filter?:string):Promise<IPagedResult<IEdoCtaReport>>
  {
    const result: IPagedResult<IEdoCtaReport> = {
      Paged:null,
      Result:[]
    }    
    const filters = {
      Page: paged.Page,      
      Search: filter
    }  
    const response:IServiceResponse = await this.Post('IndexEdoCta/ReportEdoCta',filters,null,null,null,true,false,null); 
    if(response)
    {
      result.Paged = response.Paged;
      result.Result = response.Response? response.Response:[];
    }                
    return result;
  }
  public async GetPaymentsPeriodSummary(ini?:Date,fin?:Date):Promise<IPaymentsPeriodSummary|null>
  {
    const params = {      
      Ini:ini,
      Fin:fin,
    }     
    const response:IServiceResponse = await this.Post('IndexEdoCta/GetPaymentsPeriodSummary',params,null,null,null,true,false,null);     
    if(response.Response)
    {
      return response.Response;      
    }                
    return null;
  }
  public async GetPaymentsPeriod(paged:IPagedParameters,ini?:Date,fin?:Date):Promise<IPagedResult<IInvoicePayment>>
  {    
    const result: IPagedResult<IInvoicePayment> = {
      Paged:null,
      Result:[]
    } 
    const params = {
      Page:paged.Page,
      Ini:ini,
      Fin:fin,
    }     
    const response:IServiceResponse = await this.Post('IndexEdoCta/GetPaymentsPeriod',params,null,null,null,true,false,null);     
    if(response)
    {
      result.Paged = response.Paged;
      result.Result = response.Response? response.Response:[];      
    }                
    return result;
  }
  public async GetPaymentsPeriodExcel(ini?:Date,fin?:Date):Promise<any>
  {  
    const params = {
      Ini:ini,
      Fin:fin,
    }     
    const response:IServiceResponse = await this.Post(`IndexEdoCta/GetPaymentsPeriodExcel`,params,null,null,null,true,undefined,'arraybuffer' );
    return response;
  }
}